import { useEffect, useState } from 'react'
import { getCourses } from '@/services/course'
import { Course, CourseRes } from '@/services/types/course'
import { getUserCourseLearn } from '@/services/user'
import { LearnRes } from '@/services/types/user'
import user from '@/stores/user'
import './index.less'
import { useNavigate } from 'react-router-dom'

type Props = {
  playerId: string
}
const Index = ({ playerId }: Props) => {
  document.title = '课程列表'
  const navigate = useNavigate()
  const [courses, setCourses] = useState<Course[]>([])
  const [learn, setLearn] = useState<{ [key: string]: number }>({}) // 课程学习节数 {courseId: lessonTotal}

  useEffect(() => {
    fetchCourseList()
    fetchUserLearn()
  }, [playerId])

  const fetchCourseList = async () => {
    if (!playerId) return

    try {
      const res = (await getCourses({
        course_catalog: 'chinese_chess',
        course_type: 'enlightening',
        page: 1,
        size: 100,
      })) as unknown as CourseRes
      setCourses(res.courses)
    } catch (error) {}
  }

  const fetchUserLearn = async () => {
    if (!playerId) return

    const res = (await getUserCourseLearn({ playerId })) as unknown as LearnRes
    const learnObj: any = {}
    res.courses.forEach((item) => {
      learnObj[item.courseId] = item.lessonTotal
    })
    setLearn(learnObj)
  }

  const goCourseDetail = (id: string) => {
    navigate('/course/detail', { state: { courseId: id, playerId: user.curPlayer.playerId } })
  }

  return (
    <div className="page course-info">
      <div className="course-list">
        {courses.map((item, index) => {
          return (
            <div
              className="course-item"
              key={item.course_id}
              onClick={() => goCourseDetail(item.course_id)}
            >
              <div className="name oneline">{item.course_name}</div>
              <div className="desc">{item.course_description || '描述'}</div>
              {CourseProgress({
                learnedNumber: learn[item.course_id] || 0,
                lessonTotal: item.lessons ? item.lessons.length : 0,
              })}
              {item.course_tag && <div className="tag">{item.course_tag}</div>}
              {index < courses.length - 1 && (
                <img
                  className="link"
                  src={require(`./link${index + 1 > 3 ? 3 : index + 1}.png`)}
                  alt=""
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

type CourseProgressProps = { learnedNumber: number; lessonTotal: number }
const CourseProgress = ({ learnedNumber, lessonTotal }: CourseProgressProps) => {
  const rate = lessonTotal === 0 ? 0 : ((learnedNumber / lessonTotal) * 100).toFixed()
  return (
    <>
      <div className="progress-box">
        <div className="progress">
          <div className="speed" style={{ width: rate + '%' }}></div>
        </div>
        <div className="rate">{rate}%</div>
      </div>
      {rate === '100' && <div className="status">已完成</div>}
    </>
  )
}

export default Index
